import usePoolState from '../../../../context/pool/usePoolState';
import { formatUSD } from '../../../../helpers';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
// import useUserLockUps from '../../../../hooks/web3/pools/useUserLockUps';
import useMockUserLockUps from '../../../../hooks/web3/pools/useMockUserLockUps';
import {
    NO_LOCK_EARLY_WITHDRAWAL_TIME,
    TimeConversions,
} from '../../../../config/constants';
import useCountdown from '../../../../hooks/useCountdown';

const EarlyWithdrawalPenalty = () => {
    const { withdrawAmount, selectedLiquidityPool } = usePoolState();

    // const { userLockUps } = useUserLockUps();
    const { userLockUps } = useMockUserLockUps();

    const penaltyEndTime =
        selectedLiquidityPool && userLockUps
            ? userLockUps[selectedLiquidityPool.poolId].lastDepositTimestamp +
              NO_LOCK_EARLY_WITHDRAWAL_TIME * TimeConversions.SECONDS_PER_HOUR
            : undefined;

    const { countDown } = useCountdown(
        penaltyEndTime ?? 0,
        ({ days, hours, minutes, seconds }) =>
            `${days}d : ${hours}h : ${minutes}m : ${seconds}s`
    );

    const converted = selectedLiquidityPool
        ? selectedLiquidityPool.isZeroPrice
            ? '0'
            : formatUnits(
                  parseUnits(withdrawAmount || '0', selectedLiquidityPool?.decimals)
                      .mul(
                          parseUnits(
                              selectedLiquidityPool.currentPriceEstimate,
                              selectedLiquidityPool?.decimals
                          )
                      )
                      .div(parseUnits('1', selectedLiquidityPool?.decimals)),
                  selectedLiquidityPool?.decimals
              )
        : undefined;

    return (
        <div className='early-withdrawal-warning'>
            <p>
                You are about to withdraw{' '}
                <strong>
                    {withdrawAmount
                        ? formatUSD(withdrawAmount, { minDecimals: 2, currency: '' })
                        : '-'}
                </strong>{' '}
                blpUSDC for{' '}
                <strong>
                    {converted && withdrawAmount
                        ? formatUSD(converted, { minDecimals: 2, currency: '' })
                        : '-'}
                </strong>{' '}
                USDC with <strong>No Lock</strong>. The following penalty is in effect:
            </p>
            <ul>
                <li>
                    A <strong>0.3% fee</strong> is applied, since you chose to withdraw
                    within the first 72 hours of your LATEST No Lock deposit.
                    <br /> (The penalty will be removed in <strong>{countDown}</strong>)
                </li>
            </ul>
        </div>
    );
};

export default EarlyWithdrawalPenalty;
